import { render, staticRenderFns } from "./ProjectForm.vue?vue&type=template&id=6351d5c1&"
import script from "./ProjectForm.vue?vue&type=script&lang=ts&"
export * from "./ProjectForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectForm.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports